import { render, staticRenderFns } from "./EventOrder.vue?vue&type=template&id=faf1fbea&lang=pug"
import script from "./EventOrder.vue?vue&type=script&lang=js"
export * from "./EventOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports